/** @jsx jsx */
import { Fragment } from 'react'
import { css, jsx, keyframes } from '@emotion/core'
import useMedia from 'use-media'
import { lighten } from 'polished'

export const shine = keyframes`
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
`

const shineCss = css`
  background-image: linear-gradient(
    90deg,
    ${lighten(0.05, '#dde2e6')} 25%,
    ${'#dde2e6'} 37%,
    ${lighten(0.05, '#dde2e6')} 63%
  );
  animation: ${shine} 1.4s ease infinite;
  background-size: 400% 100%;
`

const borderSekeletonCss = css`
  height: 1px;
  margin: 10px 0;
  width: calc(100% - 20px);
  background-color: rgba(221, 226, 229, 0.4);
`

const skeletonSubmitCss = css`
  border-top: 1px solid rgba(221, 226, 229, 0.4);
  margin-top: auto;
  padding: 10px;
  width: calc(100% - 20px);
  display: flex;
  justify-content: flex-end;

  .skeleton-button {
    width: 140px;
    height: 36px;
    ${shineCss};
    border-radius: 4px;
  }
`

const skeletonQuestionCss = (width = 100) => css`
  border-radius: 10px;
  width: ${width}%;
  height: 20px;
  ${shineCss};
`

const skeletonCss = css`
  width: calc(100% - 20px);
  padding: 15px 0 10px 0;

  .skeleton-question {
    ${skeletonQuestionCss()};
  }

  .skeleton-answers {
    > div {
      border-radius: 10px;
      width: 70%;
      height: 20px;
      margin: 10px 0;
      ${shineCss};
    }
  }
`

const PublicSurveySkeleton = () => {
  const isWide = useMedia({ minWidth: 400 })

  return (
    <Fragment>
      <div css={skeletonCss}>
        <div className="skeleton-question"></div>
        <div className="skeleton-answers">
          <div />
        </div>
      </div>
      <div css={borderSekeletonCss} />
      <div css={skeletonCss}>
        <div className="skeleton-question"></div>
        <div className="skeleton-answers">
          <div />
          <div />
          <div />
        </div>
      </div>
      <div css={borderSekeletonCss} />
      <div css={skeletonCss}>
        <div className="skeleton-question"></div>
        <div className="skeleton-answers"></div>
      </div>
      {isWide && (
        <Fragment>
          <div css={borderSekeletonCss} />
          <div css={skeletonCss}>
            <div className="skeleton-question"></div>
            <div className="skeleton-answers">
              <div />
              <div />
            </div>
          </div>
        </Fragment>
      )}

      <div css={skeletonSubmitCss}>
        <div className="skeleton-button" />
      </div>
    </Fragment>
  )
}

export default PublicSurveySkeleton
